import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import DocumentMeta from 'react-document-meta';
import FestivalNewsCard from './FestivalNewsCard';
import  Slider  from 'react-slick';

export default class FestivalNews extends React.Component {
  constructor(props) {
    super(props);
  };

  render() {
    if (!this.props.festivalNews.isLoaded || this.props.festivalNews.length == 0) {
      return <span />
    }

    let festivalNewsItems = '';
    festivalNewsItems = this.props.festivalNews;

    let settings = {
      autoplay: false,
      infinite: true,
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      rtl: false
    };

    let browser = this.props.browser;

    if(browser.greaterThan.phablet) {
      settings.slidesToShow = 2;
      settings.slidesToScroll = 1;
    }

    if(browser.greaterThan.tablet) {
      settings.slidesToShow = 3;
      settings.slidesToScroll = 1;
    }

    if(browser.greaterThan.tabletLandscape) {
      settings.slidesToShow = 4;
      settings.slidesToScroll = 4;
    }

    let festivalNewsList = '';
    festivalNewsList = festivalNewsItems.map((item, index) => {
      return <div key={`slide-${item.id}-${index}`}>
        <FestivalNewsCard
          newsItem = {item}
        />

      </div>;

    });


    return(
      <main>
        <div className="homeFeaturedOrgs-outerWrapper">
          <div className="homeFeaturedOrgs-innerWrapper">
            <div className="section-description home-featuredOrgs-description">Girls' Festival latest updates</div>

              <Slider { ...settings }>{festivalNewsList}</Slider>

          </div>
        </div>
      </main>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/festival/news/FestivalNews.jsx